import {
  ADD_SERVICE_PRICE_CATEGORY_FAIL,
  ADD_SERVICE_PRICE_CATEGORY_REQUEST,
  ADD_SERVICE_PRICE_CATEGORY_SUCCESS,
  DELETE_SERVICE_PRICE_PARTNER_FAIL,
  DELETE_SERVICE_PRICE_PARTNER_REQUEST,
  DELETE_SERVICE_PRICE_PARTNER_SUCCESS,
  DETAIL_SERVICE_PRICE_CATEGORY_FAIL,
  DETAIL_SERVICE_PRICE_CATEGORY_PRICE_OPTION_FAIL,
  DETAIL_SERVICE_PRICE_CATEGORY_PRICE_OPTION_REQUEST,
  DETAIL_SERVICE_PRICE_CATEGORY_PRICE_OPTION_SUCCESS,
  DETAIL_SERVICE_PRICE_CATEGORY_REQUEST,
  DETAIL_SERVICE_PRICE_CATEGORY_SUCCESS,
  DETAIL_SERVICE_PRICE_PARTNER_FAIL,
  DETAIL_SERVICE_PRICE_PARTNER_REQUEST,
  DETAIL_SERVICE_PRICE_PARTNER_SUCCESS,
  LIST_SERVICE_PRICE_CATEGORY_FAIL,
  LIST_SERVICE_PRICE_CATEGORY_REQUEST,
  LIST_SERVICE_PRICE_CATEGORY_SUCCESS,
  LIST_SERVICE_PRICE_PARTNER_FAIL,
  LIST_SERVICE_PRICE_PARTNER_REQUEST,
  LIST_SERVICE_PRICE_PARTNER_SUCCESS,
  SUMMARY_SELECT_SERVICE_PRICE_FAIL,
  SUMMARY_SELECT_SERVICE_PRICE_REQUEST,
  SUMMARY_SELECT_SERVICE_PRICE_SUCCESS
} from '../../constants/mcu-project-service-price'

const initialState = {
  loading: false,
  loadingGetSumamry: false,
  loadingCrud: false,
  loadingAdd: false,
  loadingDetailCategory: false,
  loadingDetail: false,
  loadingDetailServicePriceCategoryPriceOption: false,
  servicePricePartners: [],
  summarySelectService: [],
  servicePriceCategorys: [],
  detailServicePriceCategorys: {},
  detailServicePrice: {},
  detailServicePriceCategoryOptionPrice: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const mcuProjectServicePriceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SERVICE_PRICE_PARTNER_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SERVICE_PRICE_PARTNER_SUCCESS:
      return {
        ...state,
        loading: false,
        servicePricePartners: action.payload,
        pageable: action.pageable,
        servicePricePartner: {}
      }
    case LIST_SERVICE_PRICE_PARTNER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        servicePricePartners: action?.dummy
      }
    case DELETE_SERVICE_PRICE_PARTNER_REQUEST:
      return {
        ...state,
        loadingCrud: true
      }
    case DELETE_SERVICE_PRICE_PARTNER_SUCCESS:
      return {
        ...state,
        loadingCrud: false
      }
    case DELETE_SERVICE_PRICE_PARTNER_FAIL:
      return {
        ...state,
        loadingCrud: false,
        error: action.payload
      }
    case SUMMARY_SELECT_SERVICE_PRICE_REQUEST:
      return {
        ...state,
        loadingGetSumamry: true
      }
    case SUMMARY_SELECT_SERVICE_PRICE_SUCCESS:
      return {
        ...state,
        loadingGetSumamry: false,
        summarySelectService: action.payload
      }
    case SUMMARY_SELECT_SERVICE_PRICE_FAIL:
      return {
        ...state,
        loadingGetSumamry: false,
        error: action.payload,
        summarySelectService: []
      }
    case LIST_SERVICE_PRICE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SERVICE_PRICE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        servicePriceCategorys: action.payload
      }
    case LIST_SERVICE_PRICE_CATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        servicePriceCategorys: []
      }
    case ADD_SERVICE_PRICE_CATEGORY_REQUEST:
      return {
        ...state,
        loadingAdd: true
      }
    case ADD_SERVICE_PRICE_CATEGORY_SUCCESS:
      return {
        ...state,
        loadingAdd: false
      }
    case ADD_SERVICE_PRICE_CATEGORY_FAIL:
      return {
        ...state,
        loadingAdd: false
      }
    case DETAIL_SERVICE_PRICE_CATEGORY_REQUEST:
      return {
        ...state,
        loadingDetailCategory: true
      }
    case DETAIL_SERVICE_PRICE_CATEGORY_SUCCESS:
      return {
        ...state,
        loadingDetailCategory: false,
        detailServicePriceCategorys: action.payload
      }
    case DETAIL_SERVICE_PRICE_CATEGORY_FAIL:
      return {
        ...state,
        loadingDetailCategory: false,
        error: action.payload,
        detailServicePriceCategorys: {}
      }
    case DETAIL_SERVICE_PRICE_PARTNER_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_SERVICE_PRICE_PARTNER_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        detailServicePrice: action.payload
      }
    case DETAIL_SERVICE_PRICE_PARTNER_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload,
        detailServicePrice: {}
      }
    case DETAIL_SERVICE_PRICE_CATEGORY_PRICE_OPTION_REQUEST:
      return {
        ...state,
        loadingDetailServicePriceCategoryPriceOption: true
      }
    case DETAIL_SERVICE_PRICE_CATEGORY_PRICE_OPTION_SUCCESS:
      return {
        ...state,
        loadingDetailServicePriceCategoryPriceOption: false,
        detailServicePriceCategoryOptionPrice: action.payload
      }
    case DETAIL_SERVICE_PRICE_CATEGORY_PRICE_OPTION_FAIL:
      return {
        ...state,
        loadingDetailServicePriceCategoryPriceOption: false,
        error: action.payload,
        detailServicePriceCategoryOptionPrice: {}
      }
    default:
      return state
  }
}

export default mcuProjectServicePriceReducer
